import Auth from '../auth/Auth';
import DefaultRegion from "../models/DefaultRegion";
import { WebClient } from './WebClient'

class ApiDefaultRegion extends WebClient {
    async getDefaultRegions(): Promise<DefaultRegion[]> {
        const url = "/airport/report/default";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async updateDefaultRegion(data: DefaultRegion): Promise<DefaultRegion> {
        return this.post("/airport/report/default", data, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }


    async deleteDefaultRegion(id: number): Promise<boolean> {
        return this.delete(`/airport/report/default/${id}`, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch(() => { return false; });
    }
}

export default new ApiDefaultRegion();
